








































import Vue from 'vue'
import Setting from '@/types/Setting.interface'
export default Vue.extend({
    data() {
        return {
            loaders: []
        }
    },
    computed: {
        workspaceSettings(): Setting[] {
            //  Grab our workspace settings
            return this.$store.getters.workspaceSettings
        }
    },
    methods: {
        loading(idx: number) {
            //  Check if the switch at index is loading
            const isLoading = this.loaders.includes(idx)

            return isLoading
        },
        description(setting: Setting): string {
            //  Return the description of our setting
            return this.$store.getters.settingDescription(setting.name)
        },
        display(setting: Setting): string {
            //  Return the display name of our setting
            return this.$store.getters.settingDisplay(setting.name)
        },
        async enable(bool: boolean, idx: number): Promise<void> {
            //  Change the enabled flag on our setting with this index
            this.workspaceSettings[idx].enabled = bool

            //  Grab this setting as our payload
            const payload = this.workspaceSettings[idx]

            //  Start the loading spinner
            this.loaders.push(idx)

            //  Submit the changes to the API
            await this.$store.dispatch('settingsPut', payload)

            //  Stop the loading spinner
            this.loaders.splice(this.loaders.indexOf(idx), 1)
        }
    }
})
